import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './Levels.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import Loader from 'components/UI/Loader/Loader'
import { checkPermList } from 'helpers'
import { permissions } from 'settings/permissions'
import AddEditLevelModal from './AddEditLevelModal/AddEditLevelModal'
import RowLevel from './RowLevel/RowLevel'
import useLocalization from 'hooks/useLocalization'

const Levels = () => {
  const [levels, setLevels] = useState(null)
  const [loading, setLoading] = useState(false)

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'lvls',
    dict: {
      levels_for_clients: 'Levels for clients',
      entries: 'Entries',
      level_name: 'Level name',
      min_lessons_required:
        'Minimum number of lessons required to obtain this level',
      edit: 'Edit',
      delete: 'Delete',
      add_level: 'Add level',
      enter_name: 'Enter the name',
      edit_level: 'Edit level',
      are_you_sure: 'Are you sure',
      are_you_sure_delete_level: 'Are you sure you want to delete the level',
      save: 'Save',
    },
  })

  const fetchLevels = () => {
    superAxiosRequest({
      method: 'get',
      link: 'db/level_conditions',
    }).then(({ data }) => {
      setLevels(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchLevels()
  }, [])

  const onBeforeSubmitClient = (data) => {
    const { name, ...rest } = data
    return {
      ...rest,
      ...(name && { name: data.name }),
    }
  }

  const addAction = () => {
    const ms = {
      modalBodyComponent: () => <AddEditLevelModal />,
      button: translate.save,
      link: 'db/level_conditions',
      title: translate.add_level,
      isResponsive: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: () => {
        fetchLevels()
      },
      valid: {
        name: 'required',
        finished_lessons_count: 'required',
      },
    }
    asideModalStore.activity(ms, {})
  }

  const editAction = (data) => {
    const ms = {
      modalBodyComponent: () => <AddEditLevelModal />,
      button: translate.save,
      link: `db/level_conditions/${data?.id}`,
      title: translate.edit_level,
      isResponsive: true,
      is_put: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: (data) => {
        setLevels((prev) =>
          prev.map((action) =>
            action.id === data.id ? { ...action, ...data } : action,
          ),
        )
      },
      valid: {
        name: 'required',
        finished_lessons_count: 'required',
      },
    }
    asideModalStore.activity(ms, data)
  }

  const deleteAction = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the level?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `db/level_conditions/${data?.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          setLevels((prev) => prev.filter((action) => action?.id !== data?.id))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editAction(items)],
      ['delete', () => deleteAction(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={translate.levels_for_clients}>
          {checkPermList(permissions.add_levelcondition) && (
            <HeaderAddButton title={translate.add_level} onClick={addAction} />
          )}
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            {translate.entries}: {levels?.length || 0}
          </div>
          <div>
            {levels?.map((activity, index) => (
              <RowLevel
                key={action.id}
                activity={activity}
                index={index}
                action={action}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default Levels
